import { Directive, ViewChild } from "@angular/core";
import { MatAccordion } from "@angular/material/expansion";

@Directive({})
export class FaqBase {
  @ViewChild(MatAccordion) accordion: MatAccordion;
}
